import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'

type ListLandingFilesResult = RestSchemas['Messages.Storage.ListLandingFilesResult']
type ListLandingFilesRequest = RestSchemas['Messages.Storage.ListLandingFilesRequest']

const getSessionToken = (): string => {
  const rawToken = sessionStorage.getItem('token')
  if (!rawToken) {
    throw new Error('No token found')
  }

  const token: unknown = JSON.parse(rawToken)
  if (typeof token !== 'string' || !token) {
    throw new Error('Invalid token found')
  }

  return token
}

const listLandingFiles = async (request: ListLandingFilesRequest): Promise<ListLandingFilesResult> => {
  if (!request.appKey || !request.namespace || request.projectId == null || request.organisationId == null) {
    throw new Error('Missing required parameters')
  }

  const token = getSessionToken()
  const response = await fetch(`${ENDPOINTS.DOTNET}/rest/storage/list_landing_files`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json-patch+json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  })

  const data = (await response.json()) as ListLandingFilesResult
  if (response.ok) {
    return data
  }

  throw new Error('Failed to list landing files')
}

export function useListLandingFiles(namespace: string) {
  const { projectId, appKey, organisationId } = useAppContext()

  return useSuspenseQuery({
    queryKey: ['list-landing-files', appKey, projectId, organisationId, namespace],
    queryFn: () =>
      listLandingFiles({
        appKey,
        projectId,
        organisationId,
        namespace,
      }),
  })
}
